import React from "react";
import { Formik } from "formik";
import {
  MimaButton,
  MimaDropdown,
  MimaDropZone,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../../components";
import { amountFormatter } from "../../../utils/utils";

const RefundP2PPayment = ({
  loading,
  onSubmit,
  closeModal,
  statusData,
  validationSchema,
  singleItem,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb="5" width={38}>
        Refund P2P Payment by {singleItem.buyer.username} (Buyer)
      </MimaText>
      <Formik
        initialValues={{
          amount: 0,
          sellerStatus: "",
          files: [],
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <MimaText mb={2} labelTitle="Confirm buyer was refunded">
              {amountFormatter(singleItem.buyerDebitValue.currencyCode).format(
                singleItem?.buyerDebitValue.amount
              )}
            </MimaText>
            <MimaText mb={2} labelTitle="Confirm Reference Code">
              {singleItem?.referenceCode}
            </MimaText>
            <MimaInput
              name="amount"
              labelTitle="Amount"
              type="number"
              placeholder="Enter amount"
              value={values.amount}
              onChange={handleChange("amount")}
              onBlur={handleBlur("amount")}
              error={errors.amount}
              touched={touched.amount}
            />
            <MimaDropdown
              labelTitle="Status"
              placeholder="Select status"
              name="sellerStatus"
              data={statusData}
              value={values.sellerStatus}
              id="sellerStatus"
              onChange={(data) => {
                setFieldValue("sellerStatus", data.key);
              }}
              error={errors.sellerStatus}
              touched={touched.sellerStatus}
            />
            <MimaDropZone
              title="Upload file"
              info="maximum file Size 1MB"
              maxNumOfImages={3}
              files={values.files}
              setFiles={(newFiles) => {
                setFieldValue("files", newFiles);
              }}
              labelTitle="Upload Admin Payment Proof Urls"
              name="files"
            />
            <MimaButton
              title="Continue"
              width={38}
              onClick={handleSubmit}
              loading={loading}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};
export default RefundP2PPayment;
